import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    gender: "",
    aantalkindereren: 0,
    verderstuderen: 0,
    activiteitentijd: 0,
  },
  mutations: {
    setGender(state, value) {
      state.gender = value;
    },
    setAantalKinderen(state, value) {
      state.aantalkindereren = value;
    },
    setVerderStuderen(state, value) {
      state.verderstuderen = value;
    },
    setActiviteitentijd(state, value) {
      state.activiteitentijd = value;
    },
  },
  actions: {},
  modules: {},
});
